import React, { useEffect } from 'react';
import { Box, Typography, Avatar } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useParams } from 'react-router-dom';
import { createTheme } from '@mui/material/styles';
import { useCompanyData } from '../../shared/contexts/DataContext';
import CustomMetaData from 'src/hooks/CustomMetaData';
import { createMarkup } from '../../shared/logic/Utils';
import { bannerImage as BannerImage } from '../../shared/logic/imagesFns';
import useRTL from 'src/hooks/useRTL';
import { styled } from '@mui/system';
import "react-image-gallery/styles/css/image-gallery.css";
import MemberLogo from 'src/assets/images/placeholder.png';
// all template course card
import CourseCard1 from 'src/screens/WhiteLabels/Templates/Template1/components/CourseCard';
// import CourseCard2 from 'src/screens/WhiteLabels/Templates/Template2/components/CourseCard';
import CourseCard3 from 'src/screens/WhiteLabels/Templates/Template3/components/CourseCard';
import CourseCard4 from 'src/screens/WhiteLabels/Templates/Template4/components/CourseCard';
// all template service card
import ServiceCard1 from 'src/screens/WhiteLabels/Templates/Template1/components/ServiceCard';
import ServiceCard2 from 'src/screens/WhiteLabels/Templates/Template2/components/ServiceCard';
import ServiceCard3 from 'src/screens/WhiteLabels/Templates/Template3/components/ServiceCard';
import ServiceCard4 from 'src/screens/WhiteLabels/Templates/Template4/components/ServiceCard';

const theme = createTheme();

const BackgroundContainer = styled(Box)(({ backgroundImage }) => ({
    position: 'relative',
    height: '343px', // Adjust height as needed
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundImage: `linear-gradient(180deg, rgba(15,70,122,1) 0%, rgba(255,255,255,0) 100%), url(${backgroundImage})`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      backgroundPosition: 'center center',
    },
}));

const ProfileContainer = styled(Box)({
    position: 'absolute',
    bottom: '-105px', // Adjust this to move the profile section up/down as needed
    left: '50%',
    transform: 'translateX(-50%)', // Centers the container horizontally
    textAlign: 'center',
    // position: 'relative',
    // textAlign: 'center',
    // zIndex: 1, // Ensures profile container is above the overlay
    // marginTop: '-50px', // Pull up the profile section a bit to overlap the background
  });

const ProfileAvatar = styled(Avatar)({
    width: '210px',
    height: '210px',
    border: '4px solid white', // Border around the avatar,
    boxShadow:'0px 3px 6px #00000029',
});

const useStyles = makeStyles(() => ({
    descSpan:{
        '& li':{
        listStyle:'inherit'
        }
    },

    colDiv:{
        display:'flex',
        flexDirection:'column'
    },

    viewTab:{
        width:'85rem',
        margin:'auto',
        padding:'0px 0px 20px 0px',

        [theme.breakpoints.down('lg')]:{
            width:'48rem'
        },
        [theme.breakpoints.down('md')]:{
            width:'95%',
            // marginTop:'560px'
        },
    },

    overview:{
        backgroundColor:'#fff',
        boxShadow:'0px 0px 25px #00000017',
        borderRadius: '10px',
        padding:'17px',
        width:'calc(100% - 34px)'
    },

    overviewSpan:{
        fontSize:'20px',
        fontWeight:500
    },

    memberName:{
        fontSize:'30px',
        fontWeight:'bold',
        textTransform:'capitalize'
    },

    position:{
        fontSize:'20px',
        fontWeight:300
    }
}));

const CourseCardList = {
    '1': CourseCard1,
    '2': CourseCard3,
    '3': CourseCard3,
    '4': CourseCard4,
};

const ServiceCardList = {
    '1': ServiceCard1,
    '2': ServiceCard2,
    '3': ServiceCard3,
    '4': ServiceCard4,
};

const TeamMemberProfile = () => {
    const { data } = useCompanyData();
    const { companyData, products, courses, teams, themeDesign, t, seoDescription, seoTitle } = data || {};
    const companyId = data?.companyData ? data?.companyData?.companyId : '';
    const classes = useStyles();
    let { teamId } = useParams();
    const CourseCardComponent = CourseCardList?.[themeDesign];
    const ServiceCardComponent = ServiceCardList?.[themeDesign];

    const memberCourses = courses?.length && teamId ? courses?.filter(v=> v?.courseDeliver === teamId) : [];
    const memberServices = products?.length && teamId ? products?.filter(v=> v?.serviceDeliver === teamId) : [];
    const activeMember = teams?.length ? teams?.filter(v=> v?.id === teamId)?.[0] : {};
    const { name, position, avatar, introduction } = activeMember || {};

    useEffect(()=> {
        window.scrollTo(0, 0);
    },[]);

    return (
        <>
        <CustomMetaData
            {...{
            title: seoTitle ? `${seoTitle}${ `${name ? ` - ${name}` : ''}`}` : `${companyData?.name}${ `${name ? ` - ${name}` : ''}`}`,
            image: companyData && companyData.avatar,
            description: seoDescription || companyData?.description
            }}
        />
     
        <BackgroundContainer backgroundImage={BannerImage(data)}>
        <ProfileContainer>
            <ProfileAvatar src={avatar || MemberLogo} alt="Profile" />
        </ProfileContainer>
        
        </BackgroundContainer>
        <div className={`${classes.colDiv} ${classes.viewTab}`} style={{marginTop:'105px'}}>
            {name ? <Typography className={classes.memberName} style={{ marginTop: '37px', textAlign: 'center' }}>{name}</Typography> : null}
            {position ? <Typography className={classes.position} style={{ marginTop: '6px', textAlign: 'center' }}>{position}</Typography> : null}
            {introduction ?
            <>
                <Typography className={classes.overviewSpan} style={{marginTop:'14px'}}>{t && t('companyPage.overview')}</Typography>
                <div className={classes.overview} style={{marginTop:'31px'}}>
                    <Typography variant="body1" className={classes.descSpan} dangerouslySetInnerHTML={createMarkup(introduction)}></Typography>
                </div>
            </>
            : null
            }

        {memberCourses?.length ? 
        <>
        <Typography className={classes.overviewSpan} style={{marginTop:'90px'}}>{t && t('courses.title')}</Typography>
        <div style={{display:'flex',flexDirection:'row',alignItems:'center',flexWrap:'wrap',justifyContent:'center',marginTop:'30px'}}>
            {React.Children.toArray(memberCourses?.map(v=> {
                return <CourseCardComponent service={v} companyId={companyId} />
            }))}
        </div>
        </>
        : null
        }

        {memberServices?.length ? 
        <>
        <Typography className={classes.overviewSpan} style={{marginTop:'80px'}}>{t && t('companyPage.services')}</Typography>
        <div style={{display:'flex',flexDirection:'row',alignItems:'center',flexWrap:'wrap',justifyContent:'center',marginTop:'30px'}}>
            {React.Children.toArray(memberServices?.map(v=> {
                return <ServiceCardComponent service={v} companyId={companyId} />
            }))}
        </div>
        </>
        : null
        }

        </div>
        </>
    );
};


export default TeamMemberProfile;